module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Added","remove":"Removed","clerk":"Clerk","name":"Name","email":"Mail"},"no":{"add":"Laget","remove":"Slettet","clerk":"Ansvarlig","name":"Name","email":"Mail"}}')
  delete Component.options._Ctor
}
